// extracted by mini-css-extract-plugin
export default {"text__area":"specificStyle_text__area__SO2UP","text__area__label":"specificStyle_text__area__label__4os2R","parents__dropdown":"specificStyle_parents__dropdown__W99SF"};